export const EMS_TIPO_ID = 5;

export const esTipoEMS = (tipoId) => parseInt(tipoId, 10) === EMS_TIPO_ID;
